import { render, staticRenderFns } from "./MessageHistory.vue?vue&type=template&id=334cf7ce&scoped=true"
import script from "./MessageHistory.vue?vue&type=script&lang=js"
export * from "./MessageHistory.vue?vue&type=script&lang=js"
import style0 from "./MessageHistory.vue?vue&type=style&index=0&id=334cf7ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334cf7ce",
  null
  
)

export default component.exports